import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import classnames from 'classnames';
import PresenceOverlay from '../containers/presenceOverlay';
import styles from './presenceListItem.module.scss';
export const PresenceListItem = ({ userPresence, index, groupIndex, ownProfile, ownPresence, scroll, }) => {
    const isOwnAgent = ownProfile.id === userPresence.user.id;
    const { user: userPresenceUser, presence: userPresencePresence } = userPresence;
    const isInACW = userPresencePresence.presence_status.load_descriptions.some((loadDescription) => loadDescription.load_type === 'acw');
    const hasActivePhoneConversation = userPresencePresence.presence_status.load_descriptions.findIndex((loadDescription) => {
        var _a;
        return (loadDescription.conversation_channel === 'pstnphone' ||
            (loadDescription.conversation_channel === 'callback' &&
                (loadDescription.conversation === null ||
                    ((_a = loadDescription.conversation) === null || _a === void 0 ? void 0 : _a.is_callback_consumed) === false))) &&
            loadDescription.load_type !== 'acw' &&
            loadDescription.load_type !== 'nonlive';
    }) > -1;
    const simRingEnabled = userPresencePresence.presence_status.simultaneous_ringing === true;
    const isWorking = userPresencePresence.status === 'working';
    const isAway = userPresencePresence.status === 'away';
    const isOffline = userPresencePresence.status === 'offline';
    const isAvailableForCall = isWorking || isAway;
    const rootClass = classnames({
        [styles.root]: true,
        [styles.rootOnline]: isWorking,
        [styles.rootAway]: isAway,
        [styles.rootOffline]: isOffline,
    });
    let icon = 'circle-full';
    if (hasActivePhoneConversation) {
        icon = 'phone-bold';
    }
    else if (isInACW) {
        icon = 'clock';
    }
    else if (simRingEnabled) {
        icon = 'simultaneous-bold';
    }
    return (_jsx("li", Object.assign({ className: rootClass }, { children: _jsx(PresenceOverlay
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        , Object.assign({ 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            isOwnAgent: isOwnAgent, ownProfile: ownProfile, ownPresence: ownPresence, presence: userPresencePresence, user: userPresenceUser, isAvailableForCall: isAvailableForCall, scroll: scroll }, { children: _jsxs("div", Object.assign({ className: styles.container }, { children: [_jsx(DixaIcon, { icon: icon, className: styles.icon }), _jsxs("span", Object.assign({ className: styles.name }, { children: [userPresenceUser.name, " ", isOwnAgent ? ' (you)' : ''] }))] })) })) })));
};
